import { BookOpen, Sparkles } from 'lucide-react';

import { Button } from '@/components/ui/button';

interface WikiEmptyStateProps {
  onGenerate: () => void;
  isGenerating: boolean;
}

export const WikiEmptyState = ({
  onGenerate,
  isGenerating,
}: WikiEmptyStateProps) => {
  return (
    <div className="flex flex-col items-center justify-center h-full">
      <div className="p-4 rounded-full bg-zinc-50 mb-4">
        <BookOpen className="h-10 w-10 text-zinc-300" />
      </div>

      <h2 className="text-lg font-semibold text-zinc-800 mb-2">Matter Wiki</h2>

      <p className="text-sm text-zinc-400 max-w-sm text-center mb-6">
        Generate a comprehensive wiki that organizes all matter details into a
        structured, searchable knowledge base.
      </p>

      <Button
        variant="default"
        size="default"
        onClick={onGenerate}
        disabled={isGenerating}
      >
        <Sparkles className="h-4 w-4" />
        {isGenerating ? 'Generating...' : 'Generate Wiki'}
      </Button>
    </div>
  );
};
